import { createContext } from "react";
import { AppInfo } from "../models/appInfo";

export const appInfoContext = createContext<AppInfo | null>(null);

export const AppInfoProvider = appInfoContext.Provider;
export const AppInfoConsumer = appInfoContext.Consumer;
